module.exports = __webpack_public_path__ + "static/media/searchIcon.050e3830.png";